import { message } from 'antd';

export const logError = (content: string) => message.error({ content });

export const logSuccess = (content: string) => message.success({ content });
